module.exports = __webpack_public_path__ + "static/img/loginbg1.03489937.png";